(function () {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        // Solo actuar si es un nodo de texto
        if (node.nodeType === Node.TEXT_NODE) {
          // Si el texto recortado es ÚNICAMENTE un ";" (o varios ";") sueltos
          if (/^;+$/.test(node.nodeValue.trim())) {
            if (node.parentNode) {
              node.parentNode.removeChild(node);
            } else {
              node.nodeValue = '';
            }
          } 
          // Si el texto tiene contenido pero incluye un ; al inicio o final suelto
          else if (node.nodeValue.includes(';')) {
            // Reemplaza solo los punto y coma sobrantes sin eliminar el resto del texto
            // (Descomentar la siguiente línea si prefieres limpiar solo el carácter en vez de borrar el nodo)
            // node.nodeValue = node.nodeValue.replace(/;/g, '');
          }
        }
      });
    }
  });

  const initObserver = () => {
    if (document.body) {
      // Limpia lo que ya existía al momento de cargar
      const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
      let currentNode = walker.nextNode();
      while (currentNode) {
        const nextNode = walker.nextNode();
        if (/^;+$/.test(currentNode.nodeValue.trim())) {
          currentNode.parentNode?.removeChild(currentNode);
        }
        currentNode = nextNode;
      }

      // Observa nuevos nodos agregados dinámicamente
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();